// extracted by mini-css-extract-plugin
export var headerCell = "_5d-1";
export var loadingSpinnerContainer = "_5d-4";
export var rowWrapper = "_5d-3";
export var standaloneTable = "_5d-5";
export var table = "_5d-0";
export var white = "_5d-2";